// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> aion-management-comfy -> liberty-pointe-403b
// Generated: 2026-10-22T20:07:13.055Z
// Counts: 5 design, 70 content, 55 slot group, 1 collection binding, 9 section, 5 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Accessibility",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Apply Now",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Floor Plans",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Gallery",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 48px;\">Welcome To</span></h1><h1><span style=\"font-size: 48px;\"><span data-type=\"field-token\" data-field=\"property_name\"></span></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Interactive Map",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Neighborhood",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Pet Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Privacy Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace the Joy of Living in Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Schedule a Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Virtual Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Transparent pricing for <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Fee Information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Your pet belongs <em>here, too.</em></h3><h3></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans and find your perfect landing place in Newark at Liberty Pointe. Our pet-friendly community provides a comfortable retreat with a host of upgrades, plus friendly neighborhood vibes at an affordable price. Here you can get a workout in or relax in welcoming community spaces. Situated near major highways and employers, Liberty Pointe offers a lifestyle where work and play are right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.heading": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-form.talk_blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Liberty Pointe in Newark, DE, enjoy a vibrant lifestyle with an array of amenities like a state-of-the-art fitness center, dog park, and playground. Relax in stylish, renovated apartments equipped with modern comforts. Whether you choose a studio or a spacious two-bedroom, your perfect home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Liberty Pointe in Newark, DE, you’ll find the perfect balance of comfort and convenience. Choose from stylish one and two-bedroom apartments or cozy studios, all featuring modern amenities like in-home washers, updated kitchens, and a dog park. Experience a deposit-free community tailored for your lifestyle—apply now to secure your new home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Liberty Pointe in <a href=\"/neighborhood\">Newark, DE</a>, we offer a range of thoughtfully designed floor plans, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments. Each layout is crafted for comfort and style. Browse our available apartment homes to find the perfect space that suits your lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Liberty Pointe in Newark, DE, vibrant living meets modern comfort. Picture yourself enjoying spacious floor plans, including stylish studios and two-bedroom apartments. With amenities like a <a href=\"/amenities\">pet-friendly dog park</a>, a fully-equipped fitness center, and renovated kitchens, your dream home is just a click away! Your new adventure starts here!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.name": {
    "overrideType": "VALUE",
    "customValue": "Liberty Pointe Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy our newly updated one- and two- bedroom apartment homes for rent in Newark, Delaware.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Liberty Pointe in Newark, DE, your dream lifestyle awaits among vibrant community gems. Embrace outdoor adventures at White Clay Creek State Park or enjoy enriching experiences at the nearby University of Delaware. With <a href=\"/floor-plans\">studio, one-bedroom, and two-bedroom floor plans</a> available, the best of comfort and convenience is just a click away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 75 lb. One-time refundable pet deposit: $350 per pet. Monthly pet rent: $25 per pet.</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.stat_2_label": {
    "overrideType": "VALUE",
    "customValue": "Pet Deposit",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Liberty Pointe in Newark, DE! Access your resident portal for seamless services like rent payments and maintenance requests. Choose from our stylish studio, one, or two-bedroom floor plans that embody comfortable living. Your community awaits—log in for convenience at your fingertips!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "Download the Loft Resident Mobile App",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>At Liberty Pointe in Newark, DE, find your perfect home among our diverse floor plans, including one-bedroom, two-bedroom, and stylish studios. Embrace a vibrant lifestyle and stunning community amenities. Curious about living here? Schedule a tour today and hear firsthand from our residents about their experiences!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Thank You",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Thank you for reaching out to Liberty Pointe in Newark, DE! With a variety of thoughtfully designed floor plans, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments, we’re excited to help you find your perfect fit. Our team will be in touch soon to guide you on your journey home!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Liberty Pointe in Newark, DE, your ideal living space awaits! Whether you prefer <a href=\"/floor-plans\">a cozy studio, a spacious one-bedroom, or a versatile two-bedroom</a>, our thoughtfully designed floor plans cater to every lifestyle. Take a virtual tour today and envision your new home amidst our vibrant community!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "residentaccess.login_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Access Resident Portal Login"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-c9f9-7208-b19a-207e352152fd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright kitchen in an apartment with white cabinets, marble countertops, and stainless steel appliances at Liberty Pointe in Newark, DE."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-e734-75ee-8095-dd5253189418.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Indoor gym in a residential community with treadmills, elliptical, and a stationary bike at Liberty Pointe in Newark, DE."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d026a-2fea-71f8-82d6-1716d567fa20.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor on-site gym with two treadmills and a weight machine."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0269-d354-75f2-a45b-3bc483c1da44.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Residential community gym with weight bench, multi-gym, free weights, and a water cooler."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-03a4-72b9-ab1a-5da66821b480.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Single-story clubhouse with a patio, picnic tables, and a playground in a green apartment complex."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0269-a873-723c-9521-af578701b04d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with stainless steel appliances, white cabinets, and marble countertops."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d026a-2379-70c4-9f5c-1e1df7eaadb8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in an apartment with a bed, dresser, TV, and a large bookcase."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0267-9787-720a-81a7-56c27f0e354e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Compact bathroom with sink, mirrored cabinet, toilet, towel bar, and shower door."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-f59e-709e-9082-6dc0d1cd641b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a brick apartment building with a parking lot and landscaping at Liberty Pointe in Newark, DE."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d026a-3b16-759e-99d6-ce8e8bb91a4b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of Liberty Pointe apartment community with a brick building and landscaped lawn."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-057c-760a-abe7-b97d0f79cfff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a multifamily community with brick buildings, open green lawn, and a playground."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0269-de8a-75eb-8269-9a096fd3733e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Brick apartment building with a parking lot and leafless trees under a bright blue sky."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-f259-72cf-bb67-69135a9b7253.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor communal grilling area with two metal picnic tables, a grill, and a nearby apartment building at Liberty Pointe in Newark, DE."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d026a-2fb0-764d-917a-77ed13c2bdf6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior brick apartment buildings with a grassy courtyard, two wooden picnic tables, and grills."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0267-ede5-75f5-95c9-cc17023aaa56.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community grilling area with metal picnic tables beside an apartment building."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166328/019d0267-e1e4-7561-a121-f84955b2f2f7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground and fenced dog park with apartment buildings in the background."
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity_renewal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Renewal"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "5%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_fee_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Deposit— 2nd Pet"
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d026a-19c4-708d-aeb0-fb220a5ed50a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with dark wood cabinets, black appliances, and a window above the sink."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d026a-1979-727d-b7aa-c724964df290.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in a modern apartment with a gray sofa, glass coffee table, and large window."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d026a-198b-74c0-90f8-1d56fae2653f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment kitchen with white cabinets, stainless steel appliances, marble-look countertops, and a window above the sink."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d026a-1c4d-760b-a583-879f56b5d99c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in a modern apartment: beige walls, gray sofa, coffee table, and wall-mounted TV."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-3d1b-73b0-a327-8da3af677320.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Caffe Gelato Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Coffee"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Welcoming cafe features gourmet Italian-American fare, a robust wine list, desserts & patio seating."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4e89-70bf-949f-e1d61a9c852a.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Trader Joe's"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer)."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-6e0d-74bc-94dc-ee36bf8f386f.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "White Clay Creek State Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Outdoors"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.8"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Park featuring 37 miles of hiking & biking trails along with fishing streams & a nature center."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-37cc-723e-a319-8bddd75e45e0.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "CAVA"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.2"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-71d1-720e-bf60-7fce51805b96.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Newark Arts Alliance Inc"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Community arts nonprofit hosting exhibitions, classes & workshops for local artists on Main Street."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-952b-745c-bd33-0cd97f1eb68f.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Middle Run Valley Natural Area"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "850-acre state park offering 10 trails over 16 miles, plus the historic John C. Vansant house"
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-3c5a-76dc-bb57-7e8cbcd96817.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Grain Craft Bar + Kitchen"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Nightlife"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.6"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Rustic-chic gastropub with USB chargers at the bar offering craft beer, upscale bar eats & music."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4272-73ff-aba5-f1ebaf823969.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Klondike Kate's Restaurant & Saloon"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurant & Saloon"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.8"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Classic American fare & drinks in a circa-1880 building featuring vintage railroad station decor."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4869-76dd-b308-47f07831db5e.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Ted's Montana Grill"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Steakhouse"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Old West-style steakhouse chain known for its burgers & chops made from bison."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-3e48-724a-a793-0a03270bd8eb.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Deer Park Tavern"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Tavern & Lounge"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.3"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Landmark spot on site with Revolutionary War roots features a bar, American fare & trivia nights."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-687a-7279-bdc1-8ac3f5e25469.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cinemark Christiana and XD"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4310-726a-b2a1-8f97fc5f49ab.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "UDairy Creamery"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Ice Cream & Dessert"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.7"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Shop selling premium ice cream produced by University of Delaware agriculture students."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-c456-756e-8521-90b80b083d17.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a gray sofa, round coffee table, TV, and dining area at Liberty Pointe in Newark, DE."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-a1be-756d-b6bd-a8b11c2c849d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with dark wood cabinets, black stove and microwave, granite countertops, and a window over the sink at Liberty Pointe in Newark, DE."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-e734-75ee-8095-dd5253189418.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor gym in a residential community with treadmills, elliptical, and a stationary bike at Liberty Pointe in Newark, DE."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "homegallerypreview.photos": {
    "limit": 4,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingBottom": "30px"
    }
  },
  "hero.name": {
    "properties": {
      "paddingBottom": "50px"
    }
  },
  "propertyoverview.blurb": {
    "properties": {
      "fontWeight": "300"
    }
  },
  "residentaccess.app_heading": {
    "properties": {
      "fontWeight": "700"
    }
  }
};
